import { Injectable } from '@angular/core'
import { LoaderService } from './loader.service'
import { tap } from 'rxjs/operators'
import { AvailableCountriesGQL } from '../gql/generated'

@Injectable({
    providedIn: 'root',
})
export class CountryService {
    constructor(
        private loaderService: LoaderService,
        private availableCountriesGQL: AvailableCountriesGQL,
    ) {}

    getAvailableCountries() {
        return this.loaderService.withLoader(
            () => this.availableCountriesGQL.fetch(
              {}, 
              {
                context: {
                  headers: {
                    'vendure-token': 'K7',
                  },
                },
                fetchPolicy: 'network-only'
              }
            ).pipe(
                tap({
                    next: (response) => {
                        console.log(response)
                        return response.data?.availableCountries
                    }
                })
            ),
            CountryService.name
        )
    }
}   